import React from 'react';
import clsx from 'clsx';
import { useWhiteLabel } from '@src/whiteLabel/WhiteLabelProvider';

interface WhiteLabelLogoProps {
  showName?: boolean;
  className?: string;
  logoHeight?: string;
  nameClassName?: string;
}

export const WhiteLabelLogo: React.FC<WhiteLabelLogoProps> = ({
  showName = true,
  className,
  logoHeight = '40px',
  nameClassName,
}) => {
  const { logoUrl, brandName } = useWhiteLabel();

  return (
    <div className={clsx('flex items-center gap-2', className)}>
      {logoUrl && (
        <img
          src={logoUrl}
          alt={`${brandName} logo`}
          style={{ maxHeight: logoHeight, objectFit: 'contain' }}
        />
      )}
      {showName && (
        <h1 className={clsx('text-M-36 text-wl-primary', nameClassName)}>
          {brandName}
        </h1>
      )}
    </div>
  );
};
